import RoleManagementTable from './RoleManagementTable'

export const RoleManagement = () => {
  return (
    <RoleManagementTable />
  )
}
